import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavClockIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4648 2.5L20.7324 2.50684C23.4745 2.64602 25.6553 4.91376 25.6553 7.69043V20.4648C25.6553 23.3312 23.3312 25.6553 20.4648 25.6553H7.69043C4.82407 25.6553 2.5 23.3312 2.5 20.4648V7.69043L2.50684 7.42285C2.64588 4.68065 4.91367 2.5 7.69043 2.5H20.4648Z",
			fill: "#E2EDFF",
			stroke: "#354C8F",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 6.5,
			fill: "#354C8F",
			stroke: "#354C8F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 8.89453V14.1445H19.25",
			stroke: "#E2EDFF",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNavClockIcon;
